<header class="cald_header clearfix">
  <div class="cald_header">
    <a href="/admin/" class="cald_left"><img class="sap-logo" src="assets/images/cpq_logo_white.svg" alt="SAP"></a>
    <div class="cald_right">
      <ul>
        @if (jouleService.isEnabled()) {
          <li id="cpq-joule">
            <a href="#" (click)="toggleJoule($event)">
              @if (jouleService.jouleActive) {
                <span class="customer-menu cpq-joule-active" title="{{'Header.Joule.Assistant' | translate}}">&#xe2a4;</span>
              } @else {
                <span class="customer-menu" title="{{'Header.Joule.Assistant' | translate}}">&#xe2a3;</span>
              }
            </a>
          </li>
        }
        @if (tenantSettings.tmpSapBuiltInSupportFunctionality) {
        <li id="cpq-built-in-support" >
          <a href="#" (click)="openDSX($event)">
            <span class="customer-menu" title="{{'Header.BuiltInSupport' | translate}}">&#xe221;</span>
          </a>
        </li>
        }
        @if (tenantSettings.tmpSapCompanionFunctionality) {
          <li id="cpq-companion" >
            <a href="#">
              <span class="customer-menu" title="{{'Header.Companion.Notifications' | translate}}">&#xe239;</span>
            </a>
          </li>
        }
        <li>
          <a target="_blank" href="{{currentHelpLink}}">
            <span class="customer-menu" title="{{'Admin.Msg.Help' | translate}}">&#xe1c4;</span>
          </a>
        </li>
         @if (!user.isEuAccessCamUser) {
          <li>
            <a [href]="exitSetupLink">
              <span class="customer-menu sap-icon" title="{{'xmlExitSetup' | translate}}">&#xe0ac;</span>
            </a>
          </li>
        }
        <li>
          <a href="{{logOutLink}}">
            <span class="customer-menu sap-icon" title="{{'Admin.LogOut' | translate}}">&#xe022;</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div [ngClass]="{ 'cpq-loader-on': spinnerService.spinnerIsOn }">
    <div></div>
  </div>
</header>


